export default "__VITE_ASSET__EUcCpFla__"